/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'react',
	'react-dom',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'./nls/StringResources'
], function(
	_,
	React,
	ReactDOM,
	UI_Toolkit,
	PropTypes,
	StringResources
) {
	const { FlexLayout, FlexItem, SVGIcon, Label, Button } = UI_Toolkit;

	class TableJoinErrorComponent extends React.Component {
		static propTypes = {
			iconId: PropTypes.object.isRequired,
			message: PropTypes.object.isRequired,
			readOnly: PropTypes.bool.isRequired,
			onClick: PropTypes.function
		}

		render() {
			return (
				<FlexLayout className='tableJoin-error-container' fullHeight direction="column" justifyContent='space-between' alignItems='flex-start'>
					<FlexItem>
						<SVGIcon className='tableJoin-error-icon' iconId={this.props.iconId} size='small'/>
						<Label className='tableJoin-error-message' label={this.props.message}/>
					</FlexItem>
					<FlexItem>
						<Button
							kind='ghost'
							className='tableJoin-error-fix-edit'
							disabled={this.props.readOnly}
							onClick={this.props.onClick}>
							{StringResources.get('fixTableJoin_edit')}
						</Button>
					</FlexItem>
				</FlexLayout>
			);
		}
	}

	class TableJoinError {
		constructor(el, dashboard) {
			this.el = el;
			this.dashboard = dashboard;
			this.icons = dashboard.getFeature('Icons');

			this.errorContainerWrapper = document.createElement('div');
			this.errorContainerWrapper.classList.add('tableJoin-error-container-wrapper', 'errorContainer');
			this.el.append(this.errorContainerWrapper);
		}

		showError(message) {
			ReactDOM.render(
				<TableJoinErrorComponent
					iconId={this.icons.getIcon('critical').id}
					message={message || StringResources.get('tablesNotJoined')}
					readOnly={this.dashboard.getMode() !== this.dashboard.MODES.EDIT}
					onClick={this.onClickFixTableJoin.bind(this)}
				/>,
				this.errorContainerWrapper);
		}

		destroy() {
			if (this.errorContainerWrapper) {
				ReactDOM.unmountComponentAtNode(this.errorContainerWrapper);
				this.errorContainerWrapper.remove();
			}
		}

		onClickFixTableJoin() {
			let canvasExtensions = this.dashboard.getDashboardCoreSvc('.CanvasExtensions');
			if (canvasExtensions) {
				let splitter = canvasExtensions.splitPaneView.getSplitter();
				let handleIndex = this.dashboard.getApplicationName() === 'story' ? 1 : 0;
				splitter.toggleItemWithIndexAndBroadcast(handleIndex, true /* always show */, { sender: 'relationships' } );
			}
		}
	}

	return TableJoinError;
});
